import { render, staticRenderFns } from "./questionnaireLabel.vue?vue&type=template&id=7efb1d95&scoped=true&"
import script from "./questionnaireLabel.vue?vue&type=script&lang=js&"
export * from "./questionnaireLabel.vue?vue&type=script&lang=js&"
import style0 from "./questionnaireLabel.vue?vue&type=style&index=0&id=7efb1d95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efb1d95",
  null
  
)

export default component.exports